import React from "react";

const Footer = () => {
  var d = new Date();
  return (
    <div className="footer shinewell-fixed-footer">
      <div className="copyright text-center">
        <p className="shinewell-dash-footer-text">
          SHINEWELL SOFTTECH &nbsp;•&nbsp; © {d.getFullYear()} SHINEWELL &nbsp;•&nbsp; ALL RIGHTS RESERVED &nbsp;•&nbsp; PRIVACY POLICY &nbsp;•&nbsp; CONTACT
        </p>
      </div>
    </div>
  );
};

export default Footer;
